export const getPageNameFromPath = path => {
  const pathArr = path.split('/')
  return pathArr[pathArr.length - 1] === '' ? 'home' : pathArr[pathArr.length - 1]
}

const routes = {
  home: '/',
  walkthrough: '/walkthrough',
  resources: '/resources',
  social: '/social',
  vaultVerification: '/vault-verification',
  auth: {
    signUp: '/auth/sign-up',
    signIn: '/auth/sign-in',
    signOut: '/auth/sign-out',
    forgotPassword: '/auth/forgot-password',
  },
  claimBusiness: '/claim-business',
  verificationRoute: '/verification',
  myAccount: '/my-account',
  myBusiness: '/claimed-business',
  welcome: '/welcome',
  ownerBeneficialForm: '/ownerBeneficialForm',
  businessDetails: '/businessDetails',
  find: '/find',
  details: '/details',
  claim: '/claim',
  vault: '/vault',
  correctYourData: '/correct-your-data',
  goldenRecord: '/golden-record',
  matchConfidenceSettings: '/system-level-settings/match-confidence',
  contractTerms: '/system-level-settings/contract-terms',
  fileValidation: '/system-level-settings/batch/file-validation',
  decisionSettings: '/system-level-settings/decisioning',
  p2bSettings: '/system-level-settings/p2b',
  userManagement: '/user-management',
  batchSummary: '/batch-summary',
  monitoringReportsPage: '/monitoring-reports',
}

export default routes
